import { Button, Card, ConfigProvider, DatePicker, Form, Input, InputNumber, Radio, Select, Tooltip } from "antd"
import { useAppContext } from "../../../hooks/useAppContext"
import { useEffect } from "react"
import { SortAscendingOutlined, SortDescendingOutlined } from "@ant-design/icons"

export default function SearchComponent({ menu }) {
    const { filterParams, setFilterParams, refreshDocs } = useAppContext()
    const { department, structure } = menu
    const [form] = Form.useForm()


    const handleSubmit = (values) => {
        console.log(filterParams)
    }

    useEffect(() => {
        form.setFieldsValue(filterParams)
    }, [filterParams])

    return (
        <div style={{ padding:'5px 5px 10px 5px'}}>
            <Card
                title={<i className="fa-solid fa-magnifying-glass" style={{ fontSize: 20, color: '#b37feb' }}></i>}
                style={{ boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)' }}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleSubmit}
                    onValuesChange={handleSubmit}
                >
                    <Form.Item
                    style={{marginBottom:10}}
                        label="დეპარტამენტი"
                        name="department"
                    >
                        <Select
                            mode="multiple"
                            placeholder="აირჩიეთ დეპარტამენტი"
                            options={department?.map(dep => ({ label: dep.code, value: dep.code }))}
                            onChange={(value) => setFilterParams({ ...filterParams, department: value })}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item
                    style={{marginBottom:10}}
                        label="სტრუქტურა"
                        name="hierarchy"
                    >
                        <Select
                            mode="multiple"
                            placeholder="აირჩიეთ სტრუქტურა"
                            options={structure?.map(struc => ({ label: struc.name, value: struc.code }))}
                            onChange={(value) => setFilterParams({ ...filterParams, hierarchy: value })}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item
                    style={{marginBottom:10}}
                        label="ნომერი"
                        name="number"
                    >
                        <Input
                            placeholder="ნომერი"
                            name="number"
                            onChange={(value) => setFilterParams({ ...filterParams, number: value.target.value })}
                        />
                    </Form.Item>
                    <Form.Item
                    style={{marginBottom:10}}
                        label="სახელი"
                        name="name"
                    >
                        <Input
                            placeholder="სახელი"
                            name="name"
                            onChange={(value) => setFilterParams({ ...filterParams, name: value.target.value })}
                        />
                    </Form.Item>
                    <hr />
                    <Form.Item
                    style={{marginBottom:10}}
                        label="ატვირთვის თარიღი"
                        name="date"
                    >
                        <DatePicker.RangePicker
                            placeholder={["დან","მდე"]}
                            format="DD.MM.YY"
                            onChange={(value) => setFilterParams({ ...filterParams, date: value })}
                        />
                    </Form.Item>
                    <Form.Item
                    style={{marginBottom:10}}
                        label="სტატუსი"
                        name="status"
                        valuePropName="checked"
                    >
                        <Radio.Group
                            onChange={(value) => setFilterParams({ ...filterParams, status: value.target.value })}
                            initialValue={filterParams.status}
                        >
                            <Radio value="all">ყველა</Radio>
                            <Radio value="active">აქტიური</Radio>
                            <Radio value="inactive">გაუქმებული</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Form>
                <hr style={{ width: '100%' }} />
                <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                    style={{marginBottom:10}}
                    label="სორტირება"
                    name="sort_params"
                >
                    <Select
                        value={filterParams.sort_params}
                        defaultValue={filterParams.sort_params}
                        options={[
                            { 
                                label: (
                                    <span>
                                        <SortAscendingOutlined style={{ marginRight: 8 }} />
                                        ნომერი
                                    </span>
                                ), 
                                value: 'number-asc' 
                            }, 
                            { 
                                label: (
                                    <span>
                                        <SortDescendingOutlined style={{ marginRight: 8 }} />
                                        ნომერი
                                    </span>
                                ), 
                                value: 'number-desc' 
                            }, 
                            { 
                                label: (
                                    <span>
                                        <SortAscendingOutlined style={{ marginRight: 8 }} />
                                        აიტვირთვის თარიღი
                                    </span>
                                ), 
                                value: 'upload_date-asc' 
                            }, 
                            { 
                                label: (
                                    <span>
                                        <SortDescendingOutlined style={{ marginRight: 8 }} />
                                        აიტვირთვის თარიღი
                                    </span>
                                ), 
                                value: 'upload_date-desc' 
                            },
                            { 
                                label: (
                                    <span>
                                        <SortAscendingOutlined style={{ marginRight: 8 }} />
                                        სტატუსი
                                    </span>
                                ), 
                                value: 'is_active-asc' 
                            },
                            { 
                                label: (
                                    <span>
                                        <SortDescendingOutlined style={{ marginRight: 8 }} />
                                        სტატუსი
                                    </span>
                                ), 
                                value: 'is_active-desc' 
                            }
                        ]}
                        onChange={(value) => setFilterParams({ ...filterParams, sort_params: value })}
                        style={{ width: '100%' }}
                    />
                </Form.Item>                
                <hr style={{ width: '100%' }} />
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                    <Tooltip title="ფილტრის გასუფთავება" mouseEnterDelay={0.5}>
                        <ConfigProvider theme={{
                            components: {
                                Button: {
                                    colorPrimary: '#b37feb',
                                    colorPrimaryHover: '#9762d1',
                                },
                            },
                        }}>
                        <Button type="primary" onClick={() => {
                            setFilterParams({
                                page: 1,
                                limit: 24,
                                department: [],
                                hierarchy: [],
                                name: '',
                                status: 'all',
                                date: null,
                                number: '',
                                sort_params: 'upload_date-desc',
                                order: 'desc'
                            })
                            refreshDocs()
                        }}
                            icon={<i className="fa-solid fa-broom"></i>}
                        style={{borderRadius: '50%'}}
                        />
                        </ConfigProvider>
                    </Tooltip>
                </div>
            </Card>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height:'100%', paddingTop:10}}>
              <Card 
              style={{width:'100%',height:'100%',boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}}
              >

              </Card>
            </div>
        </div>
    )
}